import React, { memo } from 'react'
import FairCheck from '../../../History/FairCheck'

const CheckScreen = memo(() => {
	return <FairCheck type={'mob'} />
})
export default CheckScreen
